module.exports = __webpack_public_path__ + "static/media/clouds.df6ad829.webp";